import { JetpacB2BApi } from 'api' 

export interface UploadTenantFileParams {
  tenant_id: string 
  document_type: 'b_logo' | 'b_cert' | 't_cert' | 'a_sign'
}

export interface UploadTenantFileResponse {
  status: 'success' | 'error'
  status_code: number 
  message: string 
  data?: {
    file_name?: string
    mime_type?: string
    size_bytes?: number
    url?: string 
    tenant_id?: string
    document_type?: string
  }
  error?: string
  timestamp?: string 
}

class B2bFileUploadApi {
  static async uploadTenantDocuments(
    body: FormData,
    queryString: string,
    faberToken: string
  ): Promise<UploadTenantFileResponse> {
    const response = await JetpacB2BApi.httpPost(
      `tenant-detail/upload-files?${queryString}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
    return response.data
  }
}

export default B2bFileUploadApi
